import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import('../views/Home/Home.vue'),
      meta: {
        nav: 'home',
        title: '首页'
      }
    },
    {
      path: '/service/consult',
      name: 'ConsultService',
      component: () => import('../views/MainService/ConsultService.vue'),
      meta: {
        nav: 'service',
        title: '咨询服务'
      }
    },
    {
      path: '/service/tech',
      name: 'InnovativeTechService',
      component: () => import('../views/MainService/InnovativeTechService.vue'),
      meta: {
        nav: 'service',
        title: '创新技术服务'
      }
    },
    {
      path: '/service/talent',
      name: 'TalentService',
      component: () => import('../views/MainService/TalentService.vue'),
      meta: {
        nav: 'service',
        title: '人才服务'
      }
    },
    {
      path: '/strengths',
      name: 'CoreStrengths',
      component: () => import('../views/CoreStrengths/CoreStrengths.vue'),
      meta: {
        title: '核心优势'
      }
    },
    {
      path: '/case',
      name: 'TypicalCase',
      component: () => import('../views/TypicalCase/TypicalCase.vue'),
      meta: {
        title: '经典案例'
      }
    },
    {
      path: '/case/detail/:id',
      name: 'TypicalCaseDetail',
      component: () => import('../views/TypicalCase/CaseDetail/CaseDetail.vue'),
      meta: {
        title: '案例详情'
      }
    },
    //行业资讯
    {
      path: '/article',
      name: 'Article',
      component: () => import('../views/article/article.vue'),
      // meta: {
      //   title: '行业资讯'
      // },
      children: [{
        path: 'list/:id',
        component: () => import('../views/article/ArticleList.vue'),
        meta: {
          title: '行业资讯列表'
        }
      }]
    },
    {
      path: '/article/detail/:id',
      name: 'ArticleDetail',
      component: () => import('../views/article/ArticleDetail.vue'),
      meta: {
        title: '行业资讯详情'
      }
    },
    
    //关于我们
    {
      path: '/about/companyIntro',
      name: 'CompanyIntro',
      component: () => import('../views/About/CompanyIntro.vue'),
      meta: {
        nav: 'about',
        title: '公司介绍'
      }
    },
    {
      path: '/about/contact',
      name: 'CompanyIntro',
      component: () => import('../views/About/Contact.vue'),
      meta: {
        nav: 'about',
        title: '团队介绍'
      }
    },
    {
      path: '/about/teamIntro',
      name: 'CompanyIntro',
      component: () => import('../views/About/TeamIntro.vue'),
      meta: {
        nav: 'about',
        title: '联系我们'
      }
    },
    // 不存在的路由跳转
    {
      path: '*',
      component: () => import('../views/Home/Home.vue')
    }
  ]
})

// 页面滚动条置顶
router.afterEach(()=>{
  store.dispatch("scrollToTop");
})

export default router
